import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import {
  isLoading,
  LOADING,
} from "@coworker/apprestructured/src/task-management/loading";
import { ViewerTopFragmentCommonProps } from "../viewer-top-fragment/ViewerTopFragment";
import MultipleArticles from "../../../MultipleArticles/MultipleArticles";
import type { Item } from "@coworker/apprestructured/src/shared/types/item";
import { useItemsInfoQueries } from "@coworker/apprestructured/src/shared/hooks/item/useItemsInfo";

export type MultipleArticlesViewerTopFragmentConfigProps = {
  field: string;
};

type MultipleArticlesViewerTopFragmentProps = {
  configProps: MultipleArticlesViewerTopFragmentConfigProps;
  commonProps: ViewerTopFragmentCommonProps;
};

function MultipleArticlesViewerTopFragment({
  configProps,
  commonProps,
}: MultipleArticlesViewerTopFragmentProps) {
  const { field } = configProps;
  const { task } = commonProps;
  const itemNos = getByPath<string[]>(task, field);

  const itemsInfoResult = useItemsInfoQueries(
    !isLoading(itemNos) ? itemNos : []
  );

  if (isLoading(itemNos) || itemNos.length === 0) {
    return null;
  }

  const isItemsLoading = itemsInfoResult.some((result) => result.isLoading);

  const items = isItemsLoading
    ? LOADING
    : itemsInfoResult.map((result) => result.data as Item).filter(Boolean);

  return <MultipleArticles articles={items} />;
}

export default MultipleArticlesViewerTopFragment;
